import { Injectable } from '@angular/core';
import { httpResource } from '@angular/common/http';
import { environment } from '../../../environments/environment';

//Raw Markdown
interface WikiStatusExport {
	exportedAt: string;
	pagePath: string;
	sourceFile: string;
	contentHash: string;
	content: string;
}

@Injectable({ providedIn: 'root' })
export class WikiStatusService {
	public readonly statusRessource = httpResource<WikiStatusExport>(
		() => `${environment.wikiStatusBlobUrl}?t=${Date.now()}`,
	);
}
